module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }